// @flow

import type { Dispatch } from 'redux';

import { openDialog } from '../base/dialog';
import { AlertBox } from '../toolbox/components/web/AlertBox';

/**
 * Notify that we've been kicked out of the conference.
 *
 * @param {MHParticipant} participant - The {@link MHParticipant}
 * instance which initiated the kick event.
 * @param {?Function} _ - Used only in native code.
 * @param {?string} reason - Reson for removing the user.
 * @returns {Function}
 */
export function notifyKickedOut(participant: Object, _: ?Function, reason: ?string = undefined) { // eslint-disable-line no-unused-vars
    return (dispatch: Dispatch<any>) => {

        dispatch(openDialog(AlertBox, {
            alertText: reason ? reason : 'dialog.kickMessage',
            disableOverlay: true,
            submitDisabled: false,
            cancelDisabled: true,
            titleKey: 'Meeting End'
        }));

        // dispatch(showNotification({
        //     appearance: NOTIFICATION_TYPE.ERROR,
        //     hideErrorSupportLink: true,
        //     descriptionKey: reason ? reason : 'dialog.kickMessage',
        //     descriptionArguments: args,
        //     titleKey: 'dialog.kickTitle',
        //     titleArguments: args
        // }));
    };
}
